import React from 'react';
import { CircularProgress } from '@material-ui/core';
import './Loader.scss';

interface LoaderProps {
	height?: string;
	id?: string;
}

const Loader: React.FC<LoaderProps> = (props: LoaderProps) => {
	const { id, height } = props;
	return (
		<div className='loader-size-wrapper' id={id}>
			<div className={'loader-container ' + (height === 'full' && 'h-100')}>
				<CircularProgress className='loader' />
			</div>
		</div>
	);
};

export default Loader;
